import { OrderRepository } from "../../../../data/repository/order/OrderRepository";
import { ResponseState, State } from "../../../model/ResponseState";

export interface DownloadMultipleOrderReceiptsCase {
  invoke: (ids: Array<string>) => Promise<ResponseState<Blob>>;
}

export class DownloadMultipleOrderReceiptsCaseImpl
  implements DownloadMultipleOrderReceiptsCase
{
  private repository: OrderRepository;

  constructor(repository: OrderRepository) {
    this.repository = repository;
  }

  async invoke(ids: Array<string>): Promise<ResponseState<Blob>> {
    try {
      let response = await this.repository.downloadMultipleOrderReceipts(ids);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
